import { useLocation, useHistory, Switch, Route } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import HeadCras from './components/header';
import {
  AddPatientPage,
  CalendarPage,
  ControlPanelPage,
  DocumentsPage,
  HomePage,
  MeasurementsPage,
  PatientinformationPage,
  PatientOverviewPage,
  SchedulePage,
  ShopPage,
  SupportPage,
  TherapistProfilePage,
  UserProfilePage,
} from './pages/pages';
import LoginPage from './pages/LoginPage';
import { PatientTransferInfo } from '@components/patient/patient-transfer/patient-transfer-info/patient-transfer-info';
import { fetchClients, fetchSelf, setToken } from './redux/user';

export default function AppRoutes() {
  const dispatch = useDispatch();
  const loggedIn = useSelector(({ user: { loggedIn } }) => loggedIn);
  const location = useLocation();
  const history = useHistory();
  const [tokenFromQuery, setTokenFromQuery] = useState(null);

  useEffect(() => {
    // Impersonation token from the admin panel. Sent in the fragment (#token=)
    // so it never reaches a server log; ?token= is still accepted until all
    // admin panels send the fragment.
    const fromHash = new URLSearchParams(location.hash.replace(/^#/, '')).get('token');
    const fromQuery = new URLSearchParams(location.search).get('token');
    const token = fromHash || fromQuery;
    if (token) {
      setTokenFromQuery(token);
      dispatch(setToken(token));
      history.replace(location.pathname);
    }
  }, [location.hash, location.search, history, location.pathname, dispatch]);

  // 
  

  useEffect(() => {
    if (!loggedIn) return;

    dispatch(fetchSelf())
      .then(() => dispatch(fetchClients()))
      .then(console.log)
      .catch(console.log);
  }, [loggedIn, dispatch]);

  if (!loggedIn) {
    return (
      <Switch>
        <Route path="/">
          <LoginPage />
        </Route>
      </Switch>
    );
  }

  return (
    <>
      <HeadCras />
      <PatientTransferInfo />
      <Switch>
        <Route exact path="/" component={HomePage} />
        <Route path="/controlpanel" component={ControlPanelPage} />
        <Route
          path="/patientoversikt/:clientID"
          component={PatientOverviewPage}
        />
        <Route exact path="/matningar/:clientID" component={MeasurementsPage} />
        <Route
          exact
          path="/patientinformation/:clientID"
          component={PatientinformationPage}
        />
        <Route exact path="/userprofile" component={UserProfilePage} />
        <Route
          exact
          path="/therapistprofile"
          component={TherapistProfilePage}
        />
        <Route exact path="/support" component={SupportPage} />
        <Route path="/schedule/:clientID" component={SchedulePage} />
        <Route exact path="/documents" component={DocumentsPage} />
        <Route path="/addpatient" component={AddPatientPage} />
        <Route exact path="/shop" component={ShopPage} />
        <Route exact path="/calendar/:clientID" component={CalendarPage} />
      </Switch>
    </>
  );
}
